require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./parents-owna-app-web-portal.json") })
        }
      }, "path---parents-owna-app-web-portal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---parents-owna-app-web-portal!./.cache/json/parents-owna-app-web-portal.json
// module id = 1253
// module chunks = 231608221292675